import { createFileRoute } from "@tanstack/react-router";
import { PaymentScreen } from "../features/bill/payment-screen";
import { Require } from "../features/require";

export type PaySearch = { method?: "upi"; amount?: number };

/**
 * An order's payment screen (P4-T17), beside the board on wide screens like
 * the order. `method` and `amount` start it on UPI for a diner's claim (P4-T22).
 */
export const Route = createFileRoute("/orders/$orderId_/pay")({
	validateSearch: (search: Record<string, unknown>): PaySearch => ({
		...(search.method === "upi" ? { method: "upi" as const } : {}),
		...(typeof search.amount === "number" &&
		Number.isSafeInteger(search.amount) &&
		search.amount > 0
			? { amount: search.amount }
			: {}),
	}),
	component: Page,
});

function Page() {
	const { orderId } = Route.useParams();
	const search = Route.useSearch();
	return (
		<Require permission="bill.create">
			<PaymentScreen
				key={orderId}
				orderId={orderId}
				method={search.method}
				amountPaise={search.amount}
			/>
		</Require>
	);
}
